import { createContext } from 'react';
export const PopoverContext = createContext({});
//# sourceMappingURL=PopoverContext.js.map